module.exports = __webpack_public_path__ + "img/یک-رو.3ec837c7.png";